import {
  NETWORK_FEED_TYPE,
  GROUP_FEED_TYPE,
  MY_GROUPS_FEED_TYPE,
} from 'hb-react/frontoffice/apps/LiveFeed/constants/FeedType';

export const getItemTopic = ({ configType, topic, item }) => {
  switch (configType) {
    // Global topic from config (all items are from the same topic)
    case GROUP_FEED_TYPE:
      return topic;
    // Each item handle is own topic
    case MY_GROUPS_FEED_TYPE:
      return item.topic;
    case NETWORK_FEED_TYPE:
    default:
      return null;
  }
};
